/**
 * Banner Carousel
 * A lightweight fade carousel for page banners with touch/swipe support
 */

function initBannerCarousel(carousel) {
    if (!carousel) return;

    var track = carousel.querySelector('.banner-carousel__track');
    var slides = carousel.querySelectorAll('.banner-carousel__slide');
    var dots = carousel.querySelectorAll('.banner-carousel__dot');
    var prevBtn = carousel.querySelector('.banner-carousel__arrow--prev');
    var nextBtn = carousel.querySelector('.banner-carousel__arrow--next');
    var currentIndex = 0;

    // Touch/swipe variables
    var touchStartX = 0;
    var touchEndX = 0;
    var swipeThreshold = 50;

    function goToSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        currentIndex = index;

        slides.forEach(function(slide, i) {
            slide.classList.toggle('is-active', i === index);
        });

        dots.forEach(function(dot, i) {
            dot.classList.toggle('is-active', i === index);
        });
    }

    function handleSwipe() {
        var swipeDistance = touchEndX - touchStartX;
        if (Math.abs(swipeDistance) >= swipeThreshold) {
            if (swipeDistance > 0) {
                // Swiped right - go to previous slide
                goToSlide(currentIndex - 1);
            } else {
                // Swiped left - go to next slide
                goToSlide(currentIndex + 1);
            }
        }
    }

    // Touch event listeners
    if (track) {
        track.addEventListener('touchstart', function(e) {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        track.addEventListener('touchend', function(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }, { passive: true });
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', function() {
            goToSlide(currentIndex - 1);
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function() {
            goToSlide(currentIndex + 1);
        });
    }

    dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
            goToSlide(index);
        });
    });
}

// Initialize all banner carousels on page load
function initAllBannerCarousels() {
    var carousels = document.querySelectorAll('.banner-carousel');
    if (!carousels.length) return;
    
    carousels.forEach(function(carousel) {
        initBannerCarousel(carousel);
    });
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBannerCarousels);
} else {
    initAllBannerCarousels();
}

// Export for module usage
export default {
    initBannerCarousel: initBannerCarousel,
    initAllBannerCarousels: initAllBannerCarousels
};
